import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from './app.service';
import { tap } from 'rxjs/operators';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  constructor(private appService: AppService) { }

  private getAuthToken(): string | null {
    try {
      return localStorage.getItem('token');
    } catch {
      return null;
    }
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.appService.ongoingRequests += 1;
    this.appService.showLoader.next(true);
    if (!req.url.startsWith("http") && !req.url.startsWith("//")) {
      const headers: { [name: string]: string } = {
        'user-session-key': this.appService.sessionKey
      };
      // Supabase-backed clients (e.g. alldotgay) have no server-side login session, so
      // forward the supabase access token as a Bearer header. The API validates it and
      // resolves the logged-in user (used for member-rate channel switching).
      const token = this.getAuthToken();
      if (token && !req.headers.has('Authorization') && !req.headers.has('authorization')) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      req = req.clone({
        setHeaders: headers,
        withCredentials: true,
        url: this.appService.hostUrl + req.url
      });
    }

    return next.handle(req).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            if (this.appService.ongoingRequests) {
              this.appService.ongoingRequests -= 1;
            }
            if (!this.appService.ongoingRequests) {
              this.appService.showLoader.next(false);
            }
          }
        },
        error => { }
      )
    );
  }
}

@Injectable({ providedIn: 'root' })
export class QueryParamChecker  {
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const uid = route.queryParams['uid'];
    if(uid){
      sessionStorage.setItem("uid", uid);
    }
    return true;
  }
}
